import React, { useState } from 'react';
import ActionBar from './components/ActionBar';
import MarkAsDuplicateModal from 'Screens/Contextualization/Manage/components/CustomActionBar/components/MarkAsDuplicateModal';
import { MODAL_UPGRADE_LICENSE_ACTION_BAR } from 'store/modals/modals';
import ReduxModal from 'Common/Components/ReduxModal';
import UpgradeLicense from 'Common/Components/UpgradeLicense';

const CustomActionBar = () => {
  const [showDuplicateModal, toggleDuplicateModal] = useState(false);
  const [FFImage, setFFImage] = useState(null);
  const [FFDescription, setFFDescription] = useState('');

  const setFF = (image, description) => {
    setFFImage(image);
    setFFDescription(description);
  };

  return (
    <>
      <ReduxModal id={ MODAL_UPGRADE_LICENSE_ACTION_BAR }>
        <UpgradeLicense id={ MODAL_UPGRADE_LICENSE_ACTION_BAR } image={ FFImage } descriptionIntlId={ FFDescription } />
      </ReduxModal>
      { showDuplicateModal ? <MarkAsDuplicateModal hideModal={ () => toggleDuplicateModal(false) } /> : null }
      <ActionBar entity="vulns" showDuplicateModal={ () => toggleDuplicateModal(true) } setFF={ setFF } />
    </>

  );
};

export default CustomActionBar;
